import { useMemo, useState } from 'react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { TESTIMONIALS } from './consts'
import { TestimonialCard } from './components/TestimonialCard'
import { TestimonialsHeader } from './components/TestimonialsHeader'

export const TestimonialSection = () => {
  const n = TESTIMONIALS.length
  const [offset, setOffset] = useState(0)

  const showCarouselNav = n > 3

  const visible = useMemo(() => {
    if (n <= 3) return [...TESTIMONIALS]
    return [0, 1, 2].map((i) => TESTIMONIALS[(offset + i) % n])
  }, [n, offset])

  const goToPrevious = () => {
    setOffset((prev) => (prev - 1 + n) % n)
  }

  const goToNext = () => {
    setOffset((prev) => (prev + 1) % n)
  }

  if (n === 1) {
    return (
      <section id="testimonials" className="w-full bg-white">
        <Column className="mx-auto w-full max-w-3xl items-center gap-8">
          <TestimonialsHeader showNav={false} />
          <TestimonialCard featured testimonial={TESTIMONIALS[0]} />
        </Column>
      </section>
    )
  }

  return (
    <section id="testimonials" className="w-full bg-white">
      <Column className="mx-auto w-full max-w-6xl gap-10">
        <TestimonialsHeader
          showNav={showCarouselNav}
          onPrevious={goToPrevious}
          onNext={goToNext}
        />

        <Row className="w-full !flex-col items-stretch gap-4 md:!flex-row md:justify-center">
          {visible.map((testimonial) => (
            <TestimonialCard key={testimonial.id} testimonial={testimonial} />
          ))}
        </Row>
      </Column>
    </section>
  )
}
